import React from 'react';

const SecurityAccess = ({ formData, updateFormData, nextStep, prevStep }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    updateFormData({ [name]: value });
  };
  
  // Handle parking slot changes
  const handleParkingSlotChange = (e) => {
    const { value } = e.target;
    
    // Add or remove parking slot
    let updatedParkingSlots = [...formData.parkingSlotNumbers];
    if (updatedParkingSlots.includes(value)) {
      updatedParkingSlots = updatedParkingSlots.filter(slot => slot !== value);
    } else {
      updatedParkingSlots.push(value);
    }
    
    updateFormData({ parkingSlotNumbers: updatedParkingSlots });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    nextStep();
  };
  
  // Generate parking slot numbers based on vehicle types
  const generateParkingSlots = () => {
    const slots = [];
    
    // Two-wheeler slots (T1-T20)
    if (formData.vehicleTypes.includes('2-Wheeler')) {
      for (let i = 1; i <= 20; i++) {
        slots.push(`T${i}`);
      }
    }
    
    // Four-wheeler slots (F1-F20)
    if (formData.vehicleTypes.includes('4-Wheeler')) {
      for (let i = 1; i <= 20; i++) {
        slots.push(`F${i}`);
      }
    }
    
    // Other vehicle slots (O1-O10)
    if (formData.vehicleTypes.includes('Others')) {
      for (let i = 1; i <= 10; i++) {
        slots.push(`O${i}`);
      }
    }
    
    return slots;
  };
  
  const parkingSlots = generateParkingSlots();
  
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-6">Security & Access</h2>
      <p className="mb-4 text-gray-600">
        Block {formData.block}, Flat {formData.flatNumber}
      </p>
      
      <form onSubmit={handleSubmit}>
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="rfidTagNumber">
            RFID Tag Number
          </label>
          <input
            id="rfidTagNumber"
            name="rfidTagNumber"
            type="text"
            value={formData.rfidTagNumber}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="e.g., RF12345678"
          />
          <p className="text-sm text-gray-500 mt-1">Enter the RFID tag number for society access (if available)</p>
        </div>
        
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="emergencyContact">
            Emergency Contact
          </label>
          <input
            id="emergencyContact"
            name="emergencyContact"
            type="tel"
            value={formData.emergencyContact}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="10-digit mobile number"
            pattern="[0-9]{10}"
          />
          <p className="text-sm text-gray-500 mt-1">Contact number in case of emergency</p>
        </div>
        
        {parkingSlots.length > 0 && (
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Parking Slot Numbers
            </label>
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2">
              {parkingSlots.map((slot) => (
                <div key={slot} className="flex items-center">
                  <input
                    id={`slot-${slot}`}
                    type="checkbox"
                    value={slot}
                    checked={formData.parkingSlotNumbers.includes(slot)}
                    onChange={handleParkingSlotChange}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label htmlFor={`slot-${slot}`} className="ml-2 text-gray-700">
                    {slot}
                  </label>
                </div>
              ))}
            </div>
            <p className="text-sm text-gray-500 mt-2">
              T: Two-wheeler, F: Four-wheeler, O: Other vehicle
            </p>
          </div>
        )}
        
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="remarks">
            Additional Remarks
          </label>
          <textarea
            id="remarks"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            rows="3"
            placeholder="Any additional information or special requests"
          ></textarea>
        </div>
        
        <div className="flex justify-between">
          <button
            type="button"
            onClick={prevStep}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
          >
            Back
          </button>
          
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

export default SecurityAccess;
